import {downloadCSVActionFunction} from 'notebook/structured-tables/action-functions/downloadCSVActionFunction';
import GenericStructuredTableAdapter from 'notebook/structured-tables/GenericStructuredTableAdapter';
import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {
  ActionFunctions,
  StructuredTable,
  StructuredTableColumn,
  StructuredTableSchema,
} from 'notebook/structured-tables/StructuredTableConstants';
import {Table, TableReorderLocks} from 'notebook/tables/constants/TableConstants';
import {TableDimension} from 'notebook/tables/constants/TableSelectionConstants';
export interface BulkAssemblyPrimersStructuredTableMetadata {
  columns: Array<StructuredTableColumn>;
}
export interface BulkAssemblyPrimersStructuredTableRowMetadata {}

export type BulkAssemblyPrimersStructuredTable = StructuredTable<
  BulkAssemblyPrimersStructuredTableMetadata,
  BulkAssemblyPrimersStructuredTableRowMetadata
>;

/**
 * Structured table adapter describing the behavior of the primers table in bulk assembly.
 *
 * This table is never used in the notebook, and has cell values controlled by the surrounding assembly code
 * as part of the overall assembly UI.
 */
export default class BulkAssemblyPrimersStructuredTableAdapter extends GenericStructuredTableAdapter<
  BulkAssemblyPrimersStructuredTableMetadata,
  BulkAssemblyPrimersStructuredTableRowMetadata
> {
  static getAdapter(): BulkAssemblyPrimersStructuredTableAdapter {
    return getStructuredTableAdapters().BULK_ASSEMBLY_PRIMERS as BulkAssemblyPrimersStructuredTableAdapter;
  }
  getBlankRowMetadata(
    tableMetadata: BulkAssemblyPrimersStructuredTableMetadata
  ): BulkAssemblyPrimersStructuredTableRowMetadata {
    return {};
  }

  getDisplayName(structuredTable: BulkAssemblyPrimersStructuredTable): string {
    return 'Primers';
  }

  override _getAllSupportedColumns({
    metadata,
  }: {
    metadata: BulkAssemblyPrimersStructuredTableMetadata;
  }): Array<StructuredTableColumn> {
    // Columns are dynamically decided at render time, so specify them as table metadata rather
    // than defining statically.
    return metadata.columns;
  }

  override getActionFunctions(
    tableMetadata: BulkAssemblyPrimersStructuredTableMetadata,
    schemas: Array<StructuredTableSchema>
  ): ActionFunctions<
    BulkAssemblyPrimersStructuredTableMetadata,
    BulkAssemblyPrimersStructuredTableRowMetadata
  > {
    return {overflow: [downloadCSVActionFunction]};
  }

  override toTable(primersTable: BulkAssemblyPrimersStructuredTable): Table {
    const table = super.toTable(primersTable);
    return {...table, allowColumnEdits: false, lockedDims: true, allowAddRows: false};
  }

  override allowReorderDimensions(): TableReorderLocks {
    return {
      [TableDimension.ROW]: false,
      [TableDimension.COLUMN]: false,
    };
  }
}
